import { LogicalCategoryEnum } from '@onereach/billing-dto';

export const LOGICAL_CATEGORY_OPTIONS = [
  {
    label: 'Usage',
    value: LogicalCategoryEnum.USAGE,
  },
  {
    label: 'Users',
    value: LogicalCategoryEnum.USERS,
  },
  {
    label: 'Identifiers',
    value: LogicalCategoryEnum.IDENTIFIERS,
  },
];

export const TIME_UNIT_OPTIONS = [
  {
    label: '1w',
    value: '1w',
  },
  {
    label: '1d',
    value: '24h',
  },
  {
    label: '12h',
    value: '12h',
  },
  {
    label: '6h',
    value: '6h',
  },
  {
    label: '4h',
    value: '4h',
  },
  {
    label: '2h',
    value: '2h',
  },
  {
    label: '1h',
    value: '1h',
  },
];
